import axios from 'axios';
import type {
  McpConsentDecisionPayload,
  McpConsentDecisionResponse,
} from '@/types/mcp-consent';

// The MCP OAuth endpoints (/authorize, /token, /register, /authorize/decision)
// live at the app root, not under /api/v1, so they're called directly rather
// than through the shared `api` client in `client.ts` (which is scoped to
// /api/v1 and injects a Bearer token this cookie-authenticated flow doesn't
// use). `withCredentials` sends the mcp_bridge_token cookie set at login.
const endpoints = {
  decision: () => '/authorize/decision',
};

export async function submitMcpConsentDecision(
  payload: McpConsentDecisionPayload
): Promise<McpConsentDecisionResponse> {
  const { data } = await axios.post<McpConsentDecisionResponse>(
    endpoints.decision(),
    payload,
    { withCredentials: true }
  );
  return data;
}
